module.exports = __webpack_public_path__ + "static/media/toggle-off.4a1dacf2.svg";